import { urls } from './urls';
import { fts } from './fts';

export const v1 = {
  urls,
  fts,
};
